import FileModel from './globals/FileModel';

export default class ProviderLogoMediaModel extends FileModel {
  static get path() {
    return '/backend/provider_logo_media/{?id}';
  }
}
